import axiosNest from '../../api/axiosNest';

/**
 * Anulowanie zlecenia przez CS i Administrację (prace 25.10.2026,
 * S-25.10-05, przełącznik `intakeOrderCancellation`; paczka: intake).
 * Endpointy: `apps/api/src/user-offers/intake-cancellation.controller.ts`,
 * reguły: `intake-cancellation.ts` w API.
 */

/** Klucz przełącznika — dane. */
export const FEATURE_INTAKE_CANCELLATION = 'intakeOrderCancellation';

/** Najkrótszy powód — jak w API (`MIN_CANCELLATION_REASON_LENGTH`). */
export const MIN_CANCELLATION_REASON_LENGTH = 10;

export type IntakeCancellationState = 'none' | 'awaiting_tms' | 'deleted_in_tms';

export interface CancellationStep {
  at: string;
  byId: number | null;
  text: string | null;
}

export interface IntakeCancellationView {
  state: IntakeCancellationState;
  stateLabel: string;
  cancelled: CancellationStep | null;
  deletedInTms: CancellationStep | null;
  tmsStillActive: CancellationStep | null;
  cancelledByName: string | null;
  deletedInTmsByName: string | null;
}

const path = (id: number) => `/user-offers/${id}/intake-cancellation`;

export async function fetchIntakeCancellation(id: number): Promise<IntakeCancellationView> {
  const { data } = await axiosNest.get<IntakeCancellationView>(path(id));
  return data;
}

export async function cancelOrder(id: number, reason: string): Promise<IntakeCancellationView> {
  const { data } = await axiosNest.post<IntakeCancellationView>(path(id), { reason });
  return data;
}

export async function markDeletedInTms(id: number, note: string): Promise<IntakeCancellationView> {
  const { data } = await axiosNest.post<IntakeCancellationView>(`${path(id)}/deleted-in-tms`, {
    note: note.trim() === '' ? undefined : note.trim(),
  });
  return data;
}

/** Czy przycisk „Anuluj zlecenie” ma sens: stan nie jest już nieaktualny. */
export function cancellable(planningStatus: unknown, view: IntakeCancellationView | null): boolean {
  return view?.state === 'none' && planningStatus !== 'inactive';
}
